import React, {useState} from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Button, OverlayTrigger, Tooltip, Form } from 'react-bootstrap'
import { connect } from 'react-redux'
import { handleExpiredAuthState } from '../../redux/actions/authActions'
import CandidatesApi from '../../api/CandidatesApi'
import { ApiException, ExpiredSessionException } from '../../api/exceptions'

const api = new CandidatesApi();

const EnrollButton = ({ controlNumber, handleExpiredAuthState, updateHandler }) => {

  const [tardias, setTardias] = useState(false)

  const MySwal = withReactContent(Swal)

  const handlerConfirm = async () => {

    MySwal.fire({
      title: '¿Desea inscribir al alumno?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      preConfirm: (response) => {
        response && api.enroll(controlNumber, { tardias: tardias })
          .then( response => {
            Swal.fire(
              'Confirmado',
              '¡El alumno a sido inscrito correctamente!',
              'success'
            ).then(() => {
              updateHandler();
            })
          })
          .catch((error) => {
            if (error instanceof ExpiredSessionException) {
              return handleExpiredAuthState();
            }

            Swal.fire(
              'Oops...',
              (error instanceof ApiException) ? error.message : 'Hubo un error al procesar la solicitud. Intente más tarde.',
              'error'
            )
          }
        )
      }
    })
  }

  return (
    <>
    <Form.Group className="d-flex m-0 mr-3 flex-row-reverse align-items-center">
      <Form.Label className="m-0 ml-2">¿Inscripción Tardia?</Form.Label>
      <input type="checkbox" style={{ width: '20px', height: '20px'}} value={tardias} checked={tardias} onChange={() => setTardias(!tardias)}/>
    </Form.Group>
      <OverlayTrigger
        overlay={
          <Tooltip>
          <strong>Inscribir aspirante</strong>
          </Tooltip>
        }
      >
          <Button
            variant="success"
            onClick={handlerConfirm}
          >
          <b>Inscribir</b>{' '}
          <i className=" fa fa-sign-in"></i>
        </Button>
      </OverlayTrigger>
    </>
  )
}

export default connect(null, {handleExpiredAuthState})(EnrollButton)